<template>
  <div class='tip-popup' v-if='isShow'>
    <img class='tip-img' v-if="type==='warning'" src='../../assets/images/icon-hint.png'/>
    <img class='tip-img' v-else-if="type==='success'" src='../../assets/images/icon-select-circle.png'/>
    <p class='content'>{{content}}</p>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShow: false,
      resolve: '',
      promise: ''
    }
  },
  methods: {
    showMsgBox () {
      this.promise = new Promise((resolve, reject) => {
        this.isShow = true
        this.closeMsgBox()
        resolve()
      })
      // 返回promise对象
      return this.promise
    },
    closeMsgBox () {
      setTimeout(() => {
        this.isShow = false
      }, 3000)
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
